// 资讯类型： 0:展会资讯 industry 1:行业动态 industryNews 2:展会政策 policy 3:展会知识 knowledge
export enum NewsType {
  knowledge = '3',
  policy = '2',
  industryNews = '1',
  industry = '0'
}
export const fixedServiceList = [{
  accountName: null,
  avatar: "https://dcdn-jufair.jufair.com/jufair/Ba5ReEJD2MTcTcHHdySEiWCyQmsE5rZK.png",
  baseSalary: null,
  companyMobile: "13336023729",
  companyPhone: "0571-88560061",
  companyWx: "13336023729",
  companyWxQr: "https://dcdn-jufair.jufair.com/jufair/heN3TRzTK5dhEkWjBejmYriKcZak57PD.jpg",
  englishNickName: "fangyanping",
  exhibitionRate: null,
  housingFundDeduction: null,
  id: 18,
  individualCosts: 0,
  isOnlineService: 1,
  nickName: "方经理",
  pageNum: 1,
  pageSize: 10,
  postCode: "SELL",
  postName: "销售",
  postTitleCode: "1",
  postTitleName: "金牌项目经理",
  realName: "方艳萍",
  regionType: null,
  skillDesc: "",
  skillList: [
    {
      id: 183968,
      staffId: 18,
      skillCode: "exOnlineSale",
      rangeType: 2,
      rangeId: "130"
    }
  ],
  socialSecurityDeduction: null,
  staffPerformance: null,
  startOffset: 0,
  ticketRate: "{\"commission_0_0\": {\"1-100000\": \"5\"}, \"commission_0_1\": {\"1-100000\": \"5\"}, \"commission_1_0\": {\"1-100000\": \"10\"}, \"commission_1_1\": {\"1-100000\": 10}, \"commission_2_0\": {\"1-100000\": 10}, \"commission_2_1\": {\"1-100000\": 10}}",
  uid: 265078,
  workStatus: "1",
  workTime: "09:00:00-17:45:00"
},
{
  avatar: "https://dcdn-jufair.jufair.com/jufair/ht5zTfn47dHSEQaPdBAyWrQHQXAhi6xx.png",
  companyMobile: "18267164757",
  companyPhone: "0571-89099392",
  companyWx: "17685082014",
  companyWxQr: "https://dcdn-jufair.jufair.com/jufair/cbdnb3rP5eix4Ak4zx77iNj8rTe25eam.png",
  nickName: "蒋经理",
  postName: "销售",
  postTitleName: "金牌项目经理",
  realName: "蒋翠",
  skillList: [
    {
      skillCode: "exOnlineSale",
    }
  ],
}]